import { useContext, useEffect, useState } from "react";
import { ListProps } from "./Index";
import { Operation, TableHeaders } from "../../../../../utils/Enum.types";
import { Title } from "../../../../../stories/Title/Title";
import { msgType, TableHeaderProps } from "../../../../../utils/types";
import {
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { useLazyQuery, useMutation } from "@apollo/client";
import { getModifiedScrollHeight } from "../../../../../utils/UtilFunctions";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  debouncedDelay,
} from "../../../../../utils/constants";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import { GetStockUoM } from "./queries/queries";
import {
  AtsStckUoMEdge,
  AtsStckUoMOrderField,
  DeleteUomByIdResult,
  DeleteUomByIdVars,
  GetStockUoMResult,
  GetStockUoMVars,
} from "./queries/types";
import { DeleteStockUom } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import LoadingModal from "../../../../pages/LoadingModal";
import { useDebounce } from "../../../../../customHooks/useDebounce";

const List = ({ setOperation }: ListProps) => {
  const { customer_id } = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const { state, dispatch } = useContext(AppContext);
  const [Getuoms, { data, loading, fetchMore }] = useLazyQuery<
    GetStockUoMResult,
    GetStockUoMVars
  >(GetStockUoM);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [uoms, setUoms] = useState<AtsStckUoMEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [message, setMessage] = useState<msgType>({
    flag: false,
    message: "",
    operation: Operation.NONE,
  });

  const { user_details } = useLoggedInUserDetails();

  const [DeleteUom, { loading: deleteLoading }] = useMutation<
    DeleteUomByIdResult,
    DeleteUomByIdVars
  >(DeleteStockUom, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });

  const dynamicHeaders: TableHeaderProps[] = [
    {
      headerName: "Sl",
      field: "id",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
    },
    {
      headerName: `UOM`,
      field: "uom",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
    },
    {
      headerName: `Unit Description`,
      field: "uomDesc",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      flex: 1,
      hideable:false
    },
  ];
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      headerName: TableHeaders.ACTION,
      field: "actions",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_UOM_ID,
                  payload: {
                    uomId: params.row.uom_id,
                  },
                });

                setOperation(Operation.UPDATE);
              }}
            />
            <img
              src={Delete}
              alt="/"
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_UOM_ID,
                  payload: {
                    uomId: params.row.uom_id,
                  },
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  const HandleDelete = async () => {
    try {
     
      setDeleteModal(!deleteModal);
      DeleteUom({
        variables: {
          
          uom_id: state.uomId,
          user_details,
        },
        refetchQueries: [
          {
            query: GetStockUoM,
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckUoMOrderField.UOM,
              },
              
              name: EMPTY_STRING,
            },
          },
        ],
      }).then(({ data }) => {
        if (data) {
          setMessage({
            flag: true,
            message: "StockUom Deleted Sucessfully",
            operation: Operation.DELETE,
          });
        }
      });
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetStockUoM.edges;
              const pageInfo = fetchMoreResult.GetStockUoM.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetStockUoM.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetStockUoM: {
                  edges: [...uoms, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetStockUoM.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetStockUoM.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = uoms.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setUoms(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            uom: node.uom,
            uomDesc: node.uomDesc,
            uom_id: node.id,
          }))
        );
      } else {
        setUoms(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            uom: node.uom,
            uomDesc: node.uomDesc,
            uom_id: node.id,
          }))
        );
      }
      setEndCursor(data.GetStockUoM.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    if (customer_id) {
      Getuoms({
        variables: {
          after: null,
          customer_id,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckUoMOrderField.UOM,
          },
          
          name: debouncedSearch,
        },
      });
    }
  }, [customer_id, Getuoms, debouncedSearch]);

  return (
    <>
      <div className="master-data__list">
        <Title variant="subtitle1">List of UOM</Title>
        <div className="master-data__list--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "months") {
            //     setViewModal(!viewModal);
            //     handleFilterMonthDetails(params.row.month_id);
            //   }
            // }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
      </div>
      <DeleteModal
        id={state.uomId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <LoadingModal flag={loading || deleteLoading} />
    </>
  );
};

export default List;
